import React from 'react'
import SideQSub from './SideQSubT'
import '../../Questions.css'

export default function TenthChemistry() {
    return (
        <>
            <SideQSub />
            <div className="q-banner"></div>

            <div className="pdf-container">


                <div className="pdf-content">

                    <h1 className="pdf-title">Chapter Wise PDFs</h1>
                    <ol>
                        <li className="pdf-list"> <span className='float-l'>Ch-1 Chemical Reactions and Equations</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry%2FChapter%20%2D%201%20Chemical%5FReactions%5Fand%5FEquations%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-2 Acids, Bases and Salts</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry%2FChapter%20%2D%202%20Acids%5FBases%5Fand%5FSalts%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistrys"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-3 Metals and Non-Metals</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry%2FChapter%20%2D%203%20Metals%5Fand%5FNon%5FMetals%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-4 Carban and Its Compounds</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry%2FChapter%20%2D%204%20Carbon%5Fand%5FIts%5FCompounds%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-5 Periodic Classification of Elements</span>

                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry%2FChapter%20%2D%205%20Periodic%5FClassification%5Fof%5FElements%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FChemistry"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                    </ol>
                </div>





            </div>
        </>

    )
}
